import type { CSSProperties, ReactNode } from 'react';
import { cx } from '../../utils/cx';
import s from './Meter.module.css';

export type MeterProps = {
  value: number;
  max: number;
  /** Visible label, e.g. "Free occasion 2 of 3" or "9 of 12 bought". */
  label: ReactNode;
  /** Accessible text if the label isn't plain text. */
  valueText?: string;
  tone?: 'fun' | 'highlight';
  className?: string;
};

export function Meter({ value, max, label, valueText, tone = 'fun', className }: MeterProps) {
  const pct = max > 0 ? Math.min(100, Math.max(0, (value / max) * 100)) : 0;
  return (
    <div className={cx(s.meter, className)}>
      <div
        className={s.track}
        role="meter"
        aria-valuemin={0}
        aria-valuemax={max}
        aria-valuenow={value}
        aria-valuetext={valueText ?? (typeof label === 'string' ? label : undefined)}
        aria-label={typeof label === 'string' ? label : valueText}
      >
        <span className={s.fill} data-tone={tone} style={{ '--pct': `${pct}%` } as CSSProperties} />
      </div>
      <span className={s.label}>{label}</span>
    </div>
  );
}
